import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["useCache", "expiration", "useConstructionAPI"],
  _excluded2 = ["useCache", "expiration", "useConstructionAPI"],
  _excluded3 = ["useCache", "expiration", "useConstructionAPI"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import { uuidValidate } from '@adsk/docs-http-client';
import Base from './base';
import { EntityItem, ProjectItem, UserItem, RoleItem, CompanyItem } from '../models';
import { getAllData } from '../utils/admin';
import { deprecatedWarning } from '../utils/commons';
import { CANCEL_KEYS, DOCS_PRODUCTS } from '../utils/consts';
var getCacheKey = function getCacheKey(id, type, isAdmin) {
  return "projects-".concat(id, "-").concat(type, "-").concat(isAdmin ? 'admin' : 'docs');
};

/**
 * `Service` The project service, is used to fetch project related data.
 */
var Project = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Project(sdk) {
    _classCallCheck(this, Project);
    return _callSuper(this, Project, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Project, _Base);
  return _createClass(Project, [{
    key: "getDocuments",
    value: (
    /**
     * Get the project documents or versions.
     * The response is in Camel Case format. Also include detail errors.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/73bdec3f22193-shared-list-documents
     *
     * @param projectId -  the project uuid
     * @param urns - the document urns list
     * @param config - Configurable object for request parameters.
     *
     * @returns a promise that resolves to an object with a list of documents
     */
    function () {
      var _getDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, urns, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents:batch-get");
              _context.next = 3;
              return this.HttpService.dmV3.post(url, {
                urns: urns
              }, config);
            case 3:
              response = _context.sent;
              if (!(!response.data || !response.data.results)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", []);
            case 6:
              return _context.abrupt("return", response.data.results.map(EntityItem.parseV3));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDocuments(_x, _x2, _x3) {
        return _getDocuments.apply(this, arguments);
      }
      return getDocuments;
    }()
    /**
     * Get one project document or version.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/73bdec3f22193-shared-list-documents
     *
     * @param projectId -  The project uuid
     * @param docId - The document uuid or urn
     * @param config - Configurable object for overwrite request parameters.
     *
     * @returns a promise that resolves to an object with a document
     */
    )
  }, {
    key: "getDocument",
    value: (function () {
      var _getDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, docId, config) {
        var url, payload, _yield$this$HttpServi, _yield$this$HttpServi2, _yield$this$HttpServi3, _yield$this$HttpServi4, results, _yield$this$HttpServi5, errors;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents:batch-get");
              payload = uuidValidate(docId) ? {
                ids: [docId]
              } : {
                urns: [docId]
              };
              _context2.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              _yield$this$HttpServi = _context2.sent;
              _yield$this$HttpServi2 = _yield$this$HttpServi.data;
              _yield$this$HttpServi3 = _yield$this$HttpServi2 === void 0 ? {} : _yield$this$HttpServi2;
              _yield$this$HttpServi4 = _yield$this$HttpServi3.results;
              results = _yield$this$HttpServi4 === void 0 ? [] : _yield$this$HttpServi4;
              _yield$this$HttpServi5 = _yield$this$HttpServi3.errors;
              errors = _yield$this$HttpServi5 === void 0 ? [] : _yield$this$HttpServi5;
              if (!(errors.length > 0)) {
                _context2.next = 13;
                break;
              }
              throw errors[0];
            case 13:
              return _context2.abrupt("return", EntityItem.parseV3(results[0]));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getDocument(_x4, _x5, _x6) {
        return _getDocument.apply(this, arguments);
      }
      return getDocument;
    }()
    /**
     * Get the project documents or versions by ids or urns.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/73bdec3f22193-shared-list-documents
     *
     * @param projectId - The project uuid
     * @param params - query params
     * @param payload - The list payload with shape of \{ urns: string[], ids: string[] \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to a document list with EntityItem.parseV3(document)
     */
    )
  }, {
    key: "getProjectDocuments",
    value: (function () {
      var _getProjectDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId) {
        var params,
          payload,
          config,
          urlQuery,
          url,
          response,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              payload = _args3.length > 2 ? _args3[2] : undefined;
              config = _args3.length > 3 ? _args3[3] : undefined;
              urlQuery = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/documents:batch-get").concat(urlQuery);
              _context3.next = 7;
              return this.HttpService.dmV3.post(url, payload, config);
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", {
                results: (response.data.results || []).map(EntityItem.parseV3),
                errors: response.data.errors || []
              });
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProjectDocuments(_x7) {
        return _getProjectDocuments.apply(this, arguments);
      }
      return getProjectDocuments;
    }()
    /**
     * Get a oss storage urn
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Fprojects%2Fpostprojectsprojectidstorage
     *
     * @param projectId -  The project uuid
     * @param payload - the file info used to get a proper storage urn.
     *                   Like \{ fileName: 'fake-file.pdf' \}
     * @param config - Configurable object for overwrite request parameters.
     *
     * @returns a promise that can resolve to a object with storage urn.
     *                  Like \{
     *                     objectId: 'urn:XXXXX'
     *                  \}
     */
    )
  }, {
    key: "getStorage",
    value: (function () {
      var _getStorage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/projects/".concat(projectId, "/storage");
              _context4.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getStorage(_x8, _x9, _x10) {
        return _getStorage.apply(this, arguments);
      }
      return getStorage;
    }()
    /**
     * Get the project.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v1.oas2.yml?view=%2Fproject%2Fgetprojectsprojectid
     *
     * @param projectId -  The project uuid
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with project info
     */
    )
  }, {
    key: "getProject",
    value: (function () {
      var _getProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.HttpService.dmV1.get("/projects/".concat(projectId), config);
            case 2:
              response = _context5.sent;
              return _context5.abrupt("return", ProjectItem.parseV1(response.data));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getProject(_x11, _x12) {
        return _getProject.apply(this, arguments);
      }
      return getProject;
    }()
    /**
     * Update the project settings.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Fprojects%2Fpatchprojectsprojectidsettings
     *
     * @param projectId -  the project uuid
     * @param payload - the project settings info used to update.
     *                   include \{ folderFullPathEnabled, uploaderEditAttributeValuesEnabled, publicSharingEnabled, publicSharingExpiration, vectorPdfViewingEnabled \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with project settings info
     */
    )
  }, {
    key: "updateProjectSettings",
    value: (function () {
      var _updateProjectSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.HttpService.dmV2.patch("/projects/".concat(projectId, "/settings"), payload, config);
            case 2:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateProjectSettings(_x13, _x14, _x15) {
        return _updateProjectSettings.apply(this, arguments);
      }
      return updateProjectSettings;
    }()
    /**
     * Get project users.
     * https://platform.stoplight.autodesk.com/docs/docs-v1/2add38b9a2677-project-users
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/35b2c4e584406-projects-project-id-users
     *
     * @param projectId -  the project id
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getUsers",
    value: (function () {
      var _getUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, config) {
        var _this = this;
        var _ref, _ref$useCache, useCache, expiration, _ref$useConstructionA, useConstructionAPI, conf, key, users, httpConfig, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _ref = config || {}, _ref$useCache = _ref.useCache, useCache = _ref$useCache === void 0 ? true : _ref$useCache, expiration = _ref.expiration, _ref$useConstructionA = _ref.useConstructionAPI, useConstructionAPI = _ref$useConstructionA === void 0 ? false : _ref$useConstructionA, conf = _objectWithoutProperties(_ref, _excluded);
              key = getCacheKey(projectId, 'users', useConstructionAPI);
              users = this.Cache.get(key);
              if (!(!users || !useCache)) {
                _context7.next = 14;
                break;
              }
              httpConfig = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this.usersCancelToken;
                },
                setter: function setter(token) {
                  return _this.usersCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.usersCancelToken = undefined;
                }
              }), conf);
              if (!(this.Config.product === DOCS_PRODUCTS.ACC && useConstructionAPI)) {
                _context7.next = 9;
                break;
              }
              users = getAllData(function (params) {
                return _this.SDK.Admin.getProjectUsers(projectId, params, httpConfig);
              }, {
                dataKey: 'users'
              });
              _context7.next = 13;
              break;
            case 9:
              _context7.next = 11;
              return this.HttpService.dmV1.get("/projects/".concat(projectId, "/users"), httpConfig);
            case 11:
              response = _context7.sent;
              users = !response.data.users ? [] : response.data.users.map(UserItem.parseV1);
            case 13:
              // Refresh Cache data
              this.Cache.set(key, users, expiration);
            case 14:
              return _context7.abrupt("return", users);
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getUsers(_x16, _x17) {
        return _getUsers.apply(this, arguments);
      }
      return getUsers;
    }()
    /**
     * Get project roles.
     * https://platform.stoplight.autodesk.com/docs/docs-v1/da70a7df15746-project-roles
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/861e4ccd19c18-projects-p-id-roles
     *
     * @param projectId -  the project id
     * @param options - the query parameters to identify query fields with the shape of
     *                         \{
     *                           locale: 'zh-Hans'
     *                         \}
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getRoles",
    value: (function () {
      var _getRoles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(projectId, options, config) {
        var _this2 = this;
        var _ref2, _ref2$useCache, useCache, expiration, _ref2$useConstruction, useConstructionAPI, conf, key, roles, httpConfig, query, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _ref2 = config || {}, _ref2$useCache = _ref2.useCache, useCache = _ref2$useCache === void 0 ? true : _ref2$useCache, expiration = _ref2.expiration, _ref2$useConstruction = _ref2.useConstructionAPI, useConstructionAPI = _ref2$useConstruction === void 0 ? false : _ref2$useConstruction, conf = _objectWithoutProperties(_ref2, _excluded2);
              key = getCacheKey(projectId, 'roles', useConstructionAPI);
              roles = this.Cache.get(key);
              if (!(!roles || !useCache)) {
                _context8.next = 15;
                break;
              }
              httpConfig = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.rolesCancelToken;
                },
                setter: function setter(token) {
                  return _this2.rolesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.rolesCancelToken = undefined;
                }
              }), conf);
              if (!(this.Config.product === DOCS_PRODUCTS.ACC && useConstructionAPI)) {
                _context8.next = 9;
                break;
              }
              roles = getAllData(function (params) {
                return _this2.SDK.HQ.getProjectRoles(projectId, _extends({}, options, params), httpConfig);
              }, {
                dataKey: 'roles'
              });
              _context8.next = 14;
              break;
            case 9:
              query = QS.stringify(options, {
                addQueryPrefix: true
              });
              _context8.next = 12;
              return this.HttpService.dmV1.get("/projects/".concat(projectId, "/roles").concat(query), httpConfig);
            case 12:
              response = _context8.sent;
              roles = !response.data.roles ? [] : response.data.roles.map(RoleItem.parseV1);
            case 14:
              // Refresh Cache data
              this.Cache.set(key, roles, expiration);
            case 15:
              return _context8.abrupt("return", roles);
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getRoles(_x18, _x19, _x20) {
        return _getRoles.apply(this, arguments);
      }
      return getRoles;
    }()
    /**
     * Get project companies.
     * https://platform.stoplight.autodesk.com/docs/docs-v1/15aad8de42ba1-project-companies
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/0ff108d8011ee-projects-p-id-companies
     *
     * @param projectId -  the project id
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getCompanies",
    value: (function () {
      var _getCompanies = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(projectId, config) {
        var _this3 = this;
        var _ref3, _ref3$useCache, useCache, expiration, _ref3$useConstruction, useConstructionAPI, conf, key, companies, httpConfig, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _ref3 = config || {}, _ref3$useCache = _ref3.useCache, useCache = _ref3$useCache === void 0 ? true : _ref3$useCache, expiration = _ref3.expiration, _ref3$useConstruction = _ref3.useConstructionAPI, useConstructionAPI = _ref3$useConstruction === void 0 ? false : _ref3$useConstruction, conf = _objectWithoutProperties(_ref3, _excluded3);
              key = getCacheKey(projectId, 'companies', useConstructionAPI);
              companies = this.Cache.get(key);
              if (!(!companies || !useCache)) {
                _context9.next = 14;
                break;
              }
              httpConfig = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.companiesCancelToken;
                },
                setter: function setter(token) {
                  return _this3.companiesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.companiesCancelToken = undefined;
                }
              }), conf);
              if (!(this.Config.product === DOCS_PRODUCTS.ACC && useConstructionAPI)) {
                _context9.next = 9;
                break;
              }
              companies = getAllData(function (options) {
                return _this3.SDK.HQ.getProjectCompanies(projectId, options, httpConfig);
              }, {
                dataKey: 'companies'
              });
              _context9.next = 13;
              break;
            case 9:
              _context9.next = 11;
              return this.HttpService.dmV1.get("/projects/".concat(projectId, "/companies"), httpConfig);
            case 11:
              response = _context9.sent;
              companies = !response.data.companies ? [] : response.data.companies.map(CompanyItem.parseV1);
            case 13:
              // Refresh cache data
              this.Cache.set(key, companies, expiration);
            case 14:
              return _context9.abrupt("return", companies);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getCompanies(_x21, _x22) {
        return _getCompanies.apply(this, arguments);
      }
      return getCompanies;
    }()
    /**
     * Get project settings
     * https://platform.stoplight.autodesk.com/docs/docs-cp/9e30033eb5f14-get-project-settings
     *
     * @param projectId -  the project id
     * @param options - the query parameters to identify query fields with the shape of
     *                         \{
     *                           fields: ['columnsOrder']
     *                         \}
     * @param conf - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getSettings",
    value: (function () {
      var _getSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(projectId, options, conf) {
        var _this4 = this;
        var config, query, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              config = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.settingsCancelToken;
                },
                setter: function setter(token) {
                  return _this4.settingsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this4.settingsCancelToken = undefined;
                }
              }), conf);
              query = QS.stringify(options, {
                addQueryPrefix: true
              });
              _context10.next = 4;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/settings").concat(query), config);
            case 4:
              response = _context10.sent;
              return _context10.abrupt("return", response.data);
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getSettings(_x23, _x24, _x25) {
        return _getSettings.apply(this, arguments);
      }
      return getSettings;
    }()
    /**
     * Update project settings
     * https://platform.stoplight.autodesk.com/docs/docs-cp/0e696c2996d09-update-project-settings
     *
     * @param projectId -  the project id
     * @param payload - the payload to identify update fields with the shape of
     *                         \{
     *                           columnsOrder: ['name', 'title']
     *                         \}
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "updateSettings",
    value: (function () {
      var _updateSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(projectId, payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.HttpService.dmV3.patch("/projects/".concat(projectId, "/settings"), payload, config);
            case 2:
              response = _context11.sent;
              return _context11.abrupt("return", response.data);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function updateSettings(_x26, _x27, _x28) {
        return _updateSettings.apply(this, arguments);
      }
      return updateSettings;
    }()
    /**
     * batch get documents by document ids or version ids
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Documents%20operation%20APIs.oas2.yml?view=%2Fbatch-operation%2Fpostprojectsprojectiddocumentsbatchget
     *
     * @param projectId -  the project id
     * @param payload - list of document/version ids, shape of \{ ids: array[string] \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise, shape of \{ results: array, errors: array \}
     */
    )
  }, {
    key: "getDocumentsByIds",
    value: (function () {
      var _getDocumentsByIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(projectId, payload, config) {
        var response, _ref4, _ref4$results, results, _ref4$errors, errors;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:batch-get"), payload, config);
            case 2:
              response = _context12.sent;
              _ref4 = response.data || {}, _ref4$results = _ref4.results, results = _ref4$results === void 0 ? [] : _ref4$results, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? [] : _ref4$errors;
              return _context12.abrupt("return", {
                results: results.map(EntityItem.parseV3),
                errors: errors
              });
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getDocumentsByIds(_x29, _x30, _x31) {
        return _getDocumentsByIds.apply(this, arguments);
      }
      return getDocumentsByIds;
    }()
    /**
     * get project info from HQ
     * https://adminv2.api.b360-dev.autodesk.com/bim360-dev/admin/v1/swagger/#/Projects/getProject
     *
     * @param projectId -  the project id
     * @param options - this request parameters.
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with HQ project information
     * @deprecated Use Admin.getProject instead for ACC product
     */
    )
  }, {
    key: "getHQProject",
    value: (function () {
      var _getHQProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(projectId, options, config) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (this.Config.product === DOCS_PRODUCTS.ACC) {
                deprecatedWarning('Projects.getHQProject', 'Admin.getProject');
              }
              query = QS.stringify(options, {
                addQueryPrefix: true,
                arrayFormat: 'comma'
              });
              _context13.next = 4;
              return this.HttpService.adminV1.get("/projects/".concat(projectId).concat(query), config);
            case 4:
              response = _context13.sent;
              return _context13.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getHQProject(_x32, _x33, _x34) {
        return _getHQProject.apply(this, arguments);
      }
      return getHQProject;
    }()
    /**
     * get project duplicate file scan template
     * https://platform.stoplight.autodesk.com/docs/docs-cp/428551b01a00c-private-get-duplicate-scan-template
     *
     * @param projectId -  the project id
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with the shape of \{ id, projectId, createdBy, createdByName, createAt, scanFolderUrns, attributeIds, propertyNames, title, format \}
     */
    )
  }, {
    key: "getDuplicateScanTemplate",
    value: (function () {
      var _getDuplicateScanTemplate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(projectId, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/duplicate-scan-template"), config);
            case 2:
              response = _context14.sent;
              return _context14.abrupt("return", response.data || {});
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getDuplicateScanTemplate(_x35, _x36) {
        return _getDuplicateScanTemplate.apply(this, arguments);
      }
      return getDuplicateScanTemplate;
    }()
    /**
     * post scan project duplicate file request
     * https://platform.stoplight.autodesk.com/docs/docs-cp/e0d94d4ee0b7f-private-create-list-duplicate-documents-job
     *
     * @param projectId -  the project id
     * @param payload - payload with shape of \{ folderUrns, attributeIds, propertyNames, title, format \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with the shape of \{ reportId, status \}
     */
    )
  }, {
    key: "createDuplicateScan",
    value: (function () {
      var _createDuplicateScan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(projectId, payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/duplicate-scans"), payload, config);
            case 2:
              response = _context15.sent;
              return _context15.abrupt("return", response.data || {});
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function createDuplicateScan(_x37, _x38, _x39) {
        return _createDuplicateScan.apply(this, arguments);
      }
      return createDuplicateScan;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Projects';
    }
  }]);
}(Base);
export default Project;